// Detects whether an MCP server URL carries an API key / token / secret as a query parameter.
//
// Mirrors the backend UrlParamsService.SENSITIVE_PARAM_PATTERN (`.*(key|token|secret).*`,
// case-insensitive), which decides what gets masked server-side. Keep the two in sync: if the
// backend regex changes, update this too. Used to show the masking hint on the create dialog.
const SENSITIVE_PARAM_REGEX = /(key|token|secret)/i;

export const urlHasSensitiveParam = (url) => {
  if (!url || typeof url !== "string") return false;

  let query;
  try {
    query = new URL(url).search;
  } catch {
    // The user may still be typing an incomplete URL that URL() can't parse — fall back to a
    // manual split so the hint can still appear once a key-like param is present.
    const q = url.indexOf("?");
    query = q >= 0 ? url.slice(q + 1) : "";
  }

  if (!query) return false;
  const params = new URLSearchParams(query.startsWith("?") ? query.slice(1) : query);
  for (const name of params.keys()) {
    if (SENSITIVE_PARAM_REGEX.test(name)) return true;
  }
  return false;
};

export default urlHasSensitiveParam;
